import { isElectron } from "./index";

const clearDesktopWebCaches = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    } catch (error) {
      // Custom secure schemes do not expose ServiceWorker registrations in every
      // Chromium version. The main process also clears this storage before load.
      if (error?.name !== "InvalidStateError") throw error;
    }
  }

  if ("caches" in window) {
    try {
      const names = await caches.keys();
      await Promise.all(
        names
          .filter((name) => name.includes("orderly"))
          .map((name) => caches.delete(name))
      );
    } catch (error) {
      if (error?.name !== "InvalidStateError") throw error;
    }
  }
};

export const configureServiceWorker = async () => {
  if (isElectron()) {
    await clearDesktopWebCaches();
    return;
  }

  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;
  const publicUrl = process.env.PUBLIC_URL || "";
  await navigator.serviceWorker.register(`${publicUrl}/service-worker.js`);
};
